<template>
  <main id="about-us" style="background-color: #274c8e">
    <div class="bg-canvas">
      <div class="bg-gradient">
        <section id="faq-section" class="faq-section">
          <h2 class="section-header">Daftar Layanan Efunding</h2>
          <p class="section-description">
            Temukan Berbagai Produk Keuangan Syariah yang Komprehensif dan
            Dirancang<br />
            Untuk Memenuhi Kebutuhan Serta Aspirasi Finansial Anda.
          </p>
        </section>
        <section class="simpanan-wrapper">
          <div class="simpanan-box">
            <h3 class="simpanan-title">Simpanan</h3>
            <div class="simpanan-content">
              <div class="simpanan-column">
                <img :src="iconKoper" alt="" />
                <p style="color: white; font-size: 20px">Tabungan Syariah</p>
                <p style="color: #f0f0f0">
                  Wujudkan impian finansial Anda dengan Tabungan Syariah<br />
                  dikelola sesuai prinsip syariah, aman, dan penuh keberkahan<br />
                  karena menabung tak hanya soal masa depan<br />
                  tapi juga nilai yang Anda pegang.
                </p>
                <button
                  @click="$router.push('/list-produk-tabungan')"
                  style="
                    background-color: #f7bd3a;
                    color: #274c8e;
                    border: none;
                    padding: 10px 20px;
                    border-radius: 50px;
                    cursor: pointer;
                  "
                >
                  Lihat Semua Produk
                </button>
              </div>
              <div class="divider-vertical"></div>
              <div class="simpanan-column">
                <img :src="iconContainer" alt="" />
                <p style="color: white; font-size: 20px">Deposito Syariah</p>
                <p style="color: #f0f0f0">
                  Ingin keuntungan stabil tanpa riba?<br />
                  Deposito Syariah adalah solusi cerdas untuk masa depan
                  Anda,<br />
                  Tidak hanya aman, tapi juga membawa nilai keberkahan<br />
                  dalam setiap rupiah Anda.
                </p>
                <button
                  @click="$router.push('/list-produk-deposito')"
                  style="
                    background-color: #f7bd3a;
                    color: #274c8e;
                    border: none;
                    padding: 10px 20px;
                    border-radius: 50px;
                    cursor: pointer;
                  "
                >
                  Lihat Semua Produk
                </button>
              </div>
            </div>
          </div>
        </section>
        <section class="simpanan-wrapper" style="padding-top: 0px !important">
          <div class="simpanan-box">
            <h3 class="simpanan-title">Pembiayaan</h3>
            <div class="simpanan-content">
              <div class="simpanan-column">
                <img :src="iconMotor" alt="" />
                <p style="color: white; font-size: 20px; margin-top: 15px">
                  Pembiayaan Kepemilikan <br />
                  Motor Baru
                </p>
                <p style="color: #f0f0f0">
                  Wujudkan motor impianmu tanpa riba!<br />
                  Dengan Pembiayaan Motor Baru Syariah, kamu bisa punya
                  kendaraan sendiri dengan cicilan yang aman dan sesuai prinsip
                  Islam.
                </p>
                <button
                  style="
                    background-color: #00a1ca;
                    color: white;
                    border: none;
                    padding: 10px 20px;
                    border-radius: 50px;
                    cursor: pointer;
                  "
                >
                  Segera Hadir
                </button>
                <!-- <button
                  style="
                    background-color: #f7bd3a;
                    color: #274c8e;
                    border: none;
                    padding: 10px 20px;
                    border-radius: 50px;
                    cursor: pointer;
                  "
                >
                  Lihat Semua Produk
                </button> -->
              </div>
              <div
                class="divider-vertical pembiayaan-divider pembiayaan-divider-1"
              ></div>
              <div class="simpanan-column">
                <img :src="iconMobil" alt="" />
                <p style="color: white; font-size: 20px; margin-top: 15px">
                  Pembiayaan Kepemilikan <br />
                  Mobil Baru
                </p>
                <p style="color: #f0f0f0">
                  Mobil baru bukan sekadar tujuan,<br />
                  tapi bagian dari perjalanan hidup penuh berkah. Dengan
                  Pembiayaan Mobil Syariah, memiliki kendaraan impian tanpa
                  riba, tanpa waswas.
                </p>
                <button
                  style="
                    background-color: #00a1ca;
                    color: white;
                    border: none;
                    padding: 10px 20px;
                    border-radius: 50px;
                    cursor: pointer;
                  "
                >
                  Segera Hadir
                </button>
              </div>
              <div
                class="divider-vertical pembiayaan-divider pembiayaan-divider-2"
              ></div>
              <div class="simpanan-column">
                <img :src="iconMultiguna" alt="" />
                <p style="color: white; font-size: 20px; margin-top: 15px">
                  Pembiayaan<br />
                  Multiguna
                </p>
                <p style="color: #f0f0f0">
                  Wujudkan berbagai kebutuhan hidup tanpa RIBA!<br />
                  Dengan Pembiayaan Multiguna Syariah, Anda bisa<br />
                  mendapatkan dana untuk pendidikan, modal usaha, <br />
                  atau keperluan lainnya dengan akad syariah.
                </p>
                <button
                  style="
                    background-color: #00a1ca;
                    color: white;
                    border: none;
                    padding: 10px 20px;
                    border-radius: 50px;
                    cursor: pointer;
                  "
                >
                  Segera Hadir
                </button>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>

    <div style="max-width: 90%; margin: auto; padding-bottom: 100px;">

      <div
        v-for="(faq, index) in efundingFaqServices"
        :key="index"
        :ref="'faqItem' + index"
        class="mb-2"
      >
        <div
          v-b-toggle="'faq-' + index"
          variant="link"
          class="text-left faq-container"
        >
          <h1 v-html="faq.label" class="faq-title"></h1>
          <button class="nav-btn right">
            <img
              :src="ArrowLeftIcon"
              alt="ic-left"
              class="nav-btn-icon"
              :style="{ rotate: openFaqIndex === index ? '90deg' : '270deg' }"
            />
          </button>
        </div>

        <b-collapse
          :id="'faq-' + index"
          accordion="faq-accordion"
          role="tabpanel"
          @show="onFaqShow(index)"
          @shown="onFaqShown(index)"
          @hide="onFaqHide(index)"
        >
          <div v-for="(list, index) in faq.child" :key="index">
            <div class="card-item">
              <h2 class="card-title">{{ list.title }}</h2>
              <div
                class="card-description"
                style="color: #f0f0f0"
                v-html="list.description"
              ></div>
            </div>
          </div>
        </b-collapse>
      </div>
    </div>

    <CardGetStarted />

    <NewFooterClient />
  </main>
</template>

<script>
import CardJumboTron from "@/components/landing-page/cardJumbotron.vue";
import NewFooterClient from "@/components/landing-page/newFooterClient.vue";
import CardGetStarted from "@/components/landing-page/cardGetStarted.vue";
import CardAvatarImage from "@/components/landing-page/cardAvatarImage.vue";
import { efundingFaqServices } from "../utils/efunding_faq_services";
import iconContainer from "../assets/images/icon-container.png";
import iconKoper from "../assets/images/icon-koper.png";
import iconMotor from "../assets/images/icon-motor.svg";
import iconMobil from "../assets/images/icon-mobil.svg";
import iconMultiguna from "../assets/images/icon-multiguna.svg";
import ArrowLeftIcon from "../assets/images/landing_page/ic-arrow-left-orange.svg";

export default {
  name: "layanan_kami",
  components: {
    CardJumboTron,
    NewFooterClient,
    CardAvatarImage,
    CardGetStarted,
  },
  data() {
    return {
      // Assets
      iconContainer,
      iconKoper,
      iconMotor,
      iconMobil,
      iconMultiguna,
      ArrowLeftIcon,
      // Data
      efundingFaqServices,

      // Ditambahkan untuk auto-scroll + panah berputar saat accordion FAQ
      // dibuka — lihat komentar yang sama di faq.vue.
      openFaqIndex: null,
    };
  },
  methods: {
    onFaqShow(index) {
      // Instan — cuma buat panah langsung berputar begitu diklik.
      this.openFaqIndex = index;
    },
    onFaqShown(index) {
      // @shown (setelah animasi buka selesai) — bukan @show — supaya
      // animasi tutup pertanyaan lain (accordion group, durasi sama ~0.35s)
      // sudah kelar juga saat posisi scroll dihitung. Lihat komentar
      // panjang yang sama di faq.vue.
      this.$nextTick(() => this.scrollToFaq(index));
    },
    onFaqHide(index) {
      if (this.openFaqIndex === index) {
        this.openFaqIndex = null;
      }
    },
    scrollToFaq(index) {
      // ref di dalam v-for selalu jadi array di this.$refs (refInFor) di
      // Vue 2, walau nilai ref-nya sudah unik per index — lihat komentar
      // yang sama di faq.vue.
      const ref = this.$refs["faqItem" + index];
      const el = Array.isArray(ref) ? ref[0] : ref;
      if (!el) return;

      const navbar = document.querySelector(".navbar.fixed-top");
      const offset = (navbar ? navbar.offsetHeight : 80) + 16;
      const top = el.getBoundingClientRect().top + window.scrollY - offset;
      window.scrollTo({ top, behavior: "smooth" });
    },
  },
};
</script>

<style scoped>
@media (max-width: 767px) {
  .faq-section {
    padding: 60px 20px 30px 20px;
  }
}

.faq-section {
  padding: 200px 0 0px 0;
  display: grid;
  place-content: center;
  margin-bottom: 0;
}
.simpanan-wrapper {
  width: 90%;
  margin: 0 auto 0 auto;
}

.simpanan-box {
  background-color: #ffffff;
  border-radius: 10px;
  overflow: hidden;
}

.simpanan-title {
  font-size: 24px;
  font-weight: bold;
  text-align: center;
  padding: 20px;
  background-color: #ffffff;
  color: #274c8e;
  margin: 0;
  border-bottom: 1px solid #ccc;
}

.simpanan-content {
  position: relative;
  display: flex;
  background-color: #13346c;
  color: white;
  padding: 20px;
  gap: 20px;
  align-items: stretch;
  justify-content: space-between;
  height: 100%;
}
.divider-vertical {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  height: 80%;
  width: 1px;
  opacity: 0.5;
  background-color: white;
  left: 50%; /* atau posisi sesuai kebutuhan */
}
.pembiayaan-divider {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  height: 80%;
  width: 1px;
  background-color: white;
  opacity: 0.5;
}

/* Divider pertama (antara kolom 1 & 2) */
.pembiayaan-divider-1 {
  left: 33.33%;
}

/* Divider kedua (antara kolom 2 & 3) */
.pembiayaan-divider-2 {
  left: 66.66%;
}

.simpanan-column {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 10px;
  align-items: center; /* ini untuk horizontal center */
  text-align: center; /* ini untuk teks di tengah */
}
.bg-canvas {
  background-image: url("../assets/images/landing_page/img-bg-canvas.png");
}
.bg-gradient {
  background: linear-gradient(
    to top,
    rgba(39, 76, 142, 1) 20%,
    rgba(39, 76, 142, 0)
  );
}
.section-header {
  font-size: 40px;
  color: #274c8e;
  font-weight: 700;
  margin-bottom: 1rem;
  text-align: center;
  text-transform: capitalize;
  letter-spacing: 0;
}

.section-description {
  color: #fff;
  text-align: center;
  font-size: 25px;
}
.container {
  max-width: 90%;
}

.visi-misi-section {
  display: flex;
  flex-direction: column;
  gap: 3rem;
  padding: 2rem 1rem;
}

.row-section {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 2rem;
  flex-wrap: wrap;
  margin: 0 10%;
}

.row-section.reverse {
  flex-direction: row-reverse;
}

.image {
  flex: 1;
  max-width: 400px;
  width: 100%;
  border-radius: 10px;
  object-fit: cover;
}

.content {
  flex: 1;
  min-width: 280px;
  max-width: 50%;
}

.title {
  font-size: 1.8rem;
  font-weight: 700;
  margin-bottom: 1rem;
}

.nav-btn {
  background: #12336c;
  border: none;
  color: white;
  font-size: 2rem;
  padding: 5px 15px;
  cursor: pointer;
  z-index: 2;
  border-radius: 100%;
}
.nav-btn-icon {
  transition: rotate 0.3s ease;
}

.card-item {
  /* Navy tint (bukan putih) — lihat komentar yang sama di faq.vue: teks abu
   * terang di sini didesain di atas background gelap, putih transparan
   * malah menurunkan kontrasnya. */
  background-color: rgba(19, 52, 108, 0.55);
  backdrop-filter: blur(6px);
  -webkit-backdrop-filter: blur(6px);
}
.card-title {
  color: #fff;
  font-size: 20px;
  border-bottom: 1px solid #b3b3b3;
  padding-bottom: 20px;
  text-transform: capitalize;
  letter-spacing: 0;
  font-weight: 600;
}
.card-description {
  padding-top: 20px;
  color: #f0f0f0;
  font-size: 18px;
  text-align: justify;
}

@media (max-width: 767px) {
  .card-item {
    padding: 20px;
    border: 1px solid #b3b3b3;
    border-radius: 14px;
    height: 100%;
    max-width: 100vw;
    margin-bottom: 2rem;
  }
  .faq-title {
    font-size: 18px;
    color: white;
    font-weight: 600;
    text-transform: capitalize;
  }
  .faq-container {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100vw;
    max-width: 100vw;
    padding: 1rem;
    gap: 1rem;
  }
  #faq-section {
    padding: 5rem;
  }
  .divider-vertical {
    display: none;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    height: 80%;
    width: 1px;
    opacity: 0.5;
    background-color: white;
    left: 50%; /* atau posisi sesuai kebutuhan */
  }
  .simpanan-content {
    position: relative;
    display: flex;
    background-color: #13346c;
    color: white;
    padding: 20px;
    gap: 20px;
    align-items: stretch;
    justify-content: space-between;
    height: 100%;
    overflow: auto;
  }
  .simpanan-column {
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 10px;
    align-items: center; /* ini untuk horizontal center */
    text-align: center; /* ini untuk teks di tengah */
    min-width: 100%;
  }
}

@media (min-width: 768px) {
  .card-item {
    padding: 20px;
    border: 1px solid #b3b3b3;
    border-radius: 14px;
    height: 100%;
    max-width: 85vw;
    margin-bottom: 2rem;
  }
  .faq-title {
    font-size: 24px;
    color: white;
    font-weight: 600;
    text-transform: capitalize;
    margin: 20px 0;
  }
  .faq-container {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 2rem;
    width: 85vw;
    max-width: 85vw;
  }
}

@media (min-width: 1025px) {
  .card-item {
    padding: 50px;
    border: 1px solid #b3b3b3;
    border-radius: 14px;
    height: 100%;
    max-width: 85vw;
    margin-bottom: 2rem;
  }
  .faq-title {
    font-size: 36px;
    color: white;
    font-weight: 600;
    text-transform: capitalize;
  }
  .faq-container {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 85vw;
    max-width: 85vw;
  }
}
</style>



// WEBPACK FOOTER //
// src/public/layanan-kami.vue